import { createElement, memo, useMemo, useState, useEffect } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Icon from '@max/leez-icon';
import './index.scss';
import CitySelectionModal from '../CitySelection/CitySelectionModal';
const MyComponent = (props) => {
    const { cityInfo, singleCityStyle, checkedCity, _LXReport, _pageAPI } = props;
    const [visible, setVisible] = useState(false);
    const [city, setCity] = useState(checkedCity);
    useEffect(() => {
        setCity(checkedCity);
    }, [checkedCity]);
    const handleCityChange = (city) => {
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mcReport('b_daodian_lowcode_s1i934ut_mc', {
            valLab: {
                item_name: city === null || city === void 0 ? void 0 : city.title,
                item_index: city === null || city === void 0 ? void 0 : city.value
            }
        });
        setCity(city);
        setVisible(false);
    };
    const textStyle = useMemo(() => {
        return {
            bgColorHeight: singleCityStyle.fontSize == 'small' ? '48rpx' : '60rpx',
            fontSize: singleCityStyle.fontSize == 'small' ? '24rpx' : '28rpx',
            padding: singleCityStyle.fontSize == 'small' ? '12rpx 11rpx' : '18rpx 13rpx',
            textColor: singleCityStyle.textColor,
            bgColor: singleCityStyle.isBgColor ? singleCityStyle.bgColor : 'none',
            right: singleCityStyle.align === 'right' ? '24rpx' : 0
        };
    }, [singleCityStyle]);
    const textPosition = useMemo(() => {
        return singleCityStyle.align === 'right' ? {
            right: '24rpx'
        } : {};
    }, [singleCityStyle.align]);
    return <View className='city-drop-down-card' style={Object.assign({ 
        // position: 'relative',
        width: 'fit-content', borderRadius: '8rpx', height: textStyle.bgColorHeight, backgroundColor: textStyle.bgColor, padding: singleCityStyle.isBgColor ? textStyle.padding : 0 }, textPosition)} onClick={() => {
        if (!visible)
            setVisible(true);
    }}>
      <Text className='city-deop-down-text' style={{
        fontSize: textStyle.fontSize,
        color: textStyle.textColor
    }}>
        {city === null || city === void 0 ? void 0 : city.title}
      </Text>
      <View style={{
        width: '9rpx'
    }}/>
      <Icon name={visible ? 'jiantouxianshang' : 'jiantouxianxia'} type='label2' nopaddingMode={false} color={textStyle.textColor}></Icon>

      <CitySelectionModal visible={visible} city={city === null || city === void 0 ? void 0 : city.title} onCityChange={handleCityChange} onClose={() => setVisible(false)} cityData={cityInfo} {...props}/>
    </View>;
};
export default memo(MyComponent);
